/** Owned, device-specific derivatives; see scripts/build-caldwell-video.py and build-kualoa-quality-media.mjs. */
export function propertyMedia(slug?: string | null) {
  const name = slug === 'caldwell-beach-house' ? 'caldwell' : slug === 'the-kualoa-beach-house' ? 'kualoa' : null;
  if (!name) return null;
  return {
    desktopImage: `/media/property/${name === 'caldwell' ? 'caldwell-oct15-hq' : `${name}-hq`}-desktop.webp`,
    mobileImage: `/media/property/${name === 'caldwell' ? 'caldwell-oct15-hq' : `${name}-hq`}-mobile.webp`,
    desktopVideo: `/media/property/${name === 'caldwell' ? 'caldwell-oct15-hq' : `${name}-hq`}-desktop.mp4`,
    mobileVideo: `/media/property/${name === 'caldwell' ? 'caldwell-oct15-hq' : `${name}-hq`}-mobile.mp4`,
    description: name === 'caldwell'
      ? 'The Caldwell house beside the ocean, with its upper deck, palms and seawall. Silent property video; no narration.'
      : 'The Kualoa house from the water, with its beachfront garden, palms and the mountains behind it. Silent footage; no narration.',
  };
}
export type PropertyMedia = Omit<NonNullable<ReturnType<typeof propertyMedia>>, 'desktopVideo' | 'mobileVideo'> & {desktopVideo?: string; mobileVideo?: string};
/** Jared's supplied October 15 clip; original photos remain preserved. */
export const caldwellHeroMedia: PropertyMedia = propertyMedia('caldwell-beach-house')!;
